import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Legal.css';

export default function Terms() {
  const navigate = useNavigate();
  return (
    <div className="legal-page">
      <div className="legal-content animate-fade-in">
        <button className="legal-back-link" onClick={() => navigate(-1)}>← Back</button>
        <h1 className="legal-title">Terms &amp; Conditions</h1>
        <div className="legal-updated">Last Updated: April 2026</div>
        <div className="legal-text">
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing or using Fenscope, you agree to be bound by these Terms and Conditions. If you disagree with any part of the terms, you may not access the service.</p>

          <h2>2. Description of Service</h2>
          <p>Fenscope is an AI-powered productivity tool designed to help freelancers and professionals analyze client requests, manage project scopes, and organize contractual obligations.</p>

          <h2>3. Disclaimer regarding AI</h2>
          <p>The scope evaluations and draft responses generated by our AI are for informational and productivity purposes only. <strong>They do not constitute legal advice.</strong> You are solely responsible for reviewing, verifying, and modifying any generated output before sending it to your clients.</p>

          <h2>4. Fair Use &amp; Account Limitations</h2>
          <p>Your use of the service must comply with the limits of your selected usage plan (e.g. max projects, max monthly checks). We reserve the right to limit or suspend access if we determine there is abusive usage of the platform, such as attempting to bypass rate limits.</p>

          <h2>5. Limitation of Liability</h2>
          <p>In no event shall Fenscope or its developers be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the service.</p>

          <h2>6. Contact</h2>
          <p>For any questions regarding these terms, please contact us at <a href="mailto:support@fenscope.com" style={{ color: 'var(--accent)' }}>support@fenscope.com</a>.</p>
        </div>
      </div>
    </div>
  );
}
